import React from "react";

const stats = [
  { value: "20+", label: "Anos de tradição" },
  { value: "500+", label: "Empresas atendidas" },
  { value: "50k+", label: "Peças produzidas/ano" },
  { value: "98%", label: "Índice de recompra" },
];

const About = ({ onQuoteClick }) => {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="py-24 lg:py-32 bg-white overflow-hidden"
    >
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-7 space-y-8">
            <div>
              <span
                className="inline-block text-[0.72rem] font-semibold uppercase tracking-[0.28em] text-[var(--mn-gold)] mb-4"
                data-testid="about-eyebrow"
              >
                Sobre a M NAIEF · Nossa história
              </span>
              <h2 className="font-serif-display font-bold text-3xl md:text-4xl lg:text-5xl leading-[1.1] text-[var(--mn-black)] mb-6">
                Modernidade sustentada por
                <br />
                <span className="italic text-[var(--mn-gold)]">20 anos de tradição</span>
              </h2>
            </div>

            <div className="space-y-5 text-[var(--mn-dark)] text-base md:text-[1.02rem] leading-relaxed max-w-xl">
              <p>
                A <strong className="font-semibold text-[var(--mn-black)]">M NAIEF Brindes Personalizados</strong> nasce com uma identidade moderna, levando inovação e qualidade em brindes corporativos para empresas que valorizam cada detalhe.
              </p>
              <p>
                Nossa trajetória é fortalecida pela experiência da <strong className="font-semibold text-[var(--mn-black)]">ROSE S Sacolas</strong> — empresa consolidada há mais de <strong className="text-[var(--mn-gold)]">20 anos no mercado</strong>, reconhecida pela excelência em embalagens personalizadas e atendimento diferenciado.
              </p>
              <p>
                Essa combinação nos permite entregar produtos com <strong className="font-semibold text-[var(--mn-black)]">acabamento premium</strong>, agilidade de produção e o cuidado artesanal de quem construiu reputação uma peça de cada vez.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-4">
              {stats.map((s) => (
                <div key={s.label} data-testid={`about-stat-${s.value}`}>
                  <div className="font-serif-display font-bold text-3xl md:text-4xl text-[var(--mn-gold)] leading-none">
                    {s.value}
                  </div>
                  <div className="mt-2 text-[0.7rem] uppercase tracking-[0.22em] font-semibold text-[var(--mn-dark)]">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>

            <button
              type="button"
              onClick={onQuoteClick}
              data-testid="about-cta"
              className="btn-mn-primary !py-4 !px-8 mt-2"
            >
              <i className="fa-regular fa-paper-plane" />
              Solicitar meu orçamento
            </button>
          </div>

          <aside className="lg:col-span-5">
            <div className="p-8 lg:p-10 rounded-lg bg-[#FAF7F2] border border-[var(--mn-gold)]/25 shadow-[0_20px_60px_-30px_rgba(153,101,21,0.35)]">
              <div className="text-[0.68rem] uppercase tracking-[0.28em] font-semibold text-[var(--mn-gold)] mb-6">
                Empresa do grupo
              </div>
              <div className="bg-white rounded-md p-8 mb-6 flex items-center justify-center min-h-[160px] border border-[var(--mn-black)]/[0.06]">
                <img
                  src="/brand/roses-logo-512.png"
                  alt="ROSE S Sacolas — 20 anos de tradição"
                  data-testid="roses-logo-about"
                  className="max-h-[110px] w-auto object-contain"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <h3 className="font-serif-display font-bold text-2xl text-[var(--mn-black)] mb-3">
                ROSE S Sacolas
              </h3>
              <p className="text-sm text-[var(--mn-dark)] leading-relaxed mb-6">
                Mais de <strong className="text-[var(--mn-gold)]">20 anos de tradição</strong> no mercado de embalagens e brindes personalizados. Referência em qualidade, atendimento e entrega — a base sólida que sustenta a M NAIEF Brindes.
              </p>
              <div className="grid grid-cols-2 gap-4 pt-4 border-t border-[var(--mn-black)]/10">
                <div>
                  <div className="text-[0.65rem] uppercase tracking-[0.2em] font-semibold text-[var(--mn-dark)]/60 mb-1">Desde</div>
                  <div className="font-serif-display font-bold text-xl text-[var(--mn-black)]">2005</div>
                </div>
                <div>
                  <div className="text-[0.65rem] uppercase tracking-[0.2em] font-semibold text-[var(--mn-dark)]/60 mb-1">Especialidade</div>
                  <div className="font-serif-display font-bold text-sm text-[var(--mn-black)] leading-tight">Embalagens & brindes</div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default About;
